<template>
    <div class="rounded-md border border-[#E5E7EB] bg-white p-4">
        <slot></slot>
    </div>
</template>

<script setup lang="ts"></script>
